var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"result"}},[_c('span',{attrs:{"id":"text"}},[_vm._v("검색 결과")]),(_vm.item)?_c('div',[_c('span',{attrs:{"id":"item"}},[_vm._v(_vm._s(_vm.item))]),_c('button',{on:{"click":_vm.deleteInput}})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }